import { render, staticRenderFns } from "./CreateQuote.vue?vue&type=template&id=cd279906"
import script from "./CreateQuote.vue?vue&type=script&lang=js"
export * from "./CreateQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports